<div *ngIf="!showCommentForm" [ngClass]="styles.collapseComment" (click)="activateCommentForm()">
	<span [ngClass]="styles.placeHolderIcon" class="glyphicons pencil" [title]="'Media_Videos_Comments_AddComment' | translate "></span>
	<div [ngClass]="styles.collapseCommentPlaceHolder">
		{{ 'Media_Videos_Comments_AddComment' | translate }}
	</div>
	<button type="button" [ngClass]="styles.btn" vbUiBtnPrimary>
		{{ 'Media_Videos_Comments_Post' | translate }}
	</button>
</div>

<section *ngIf="showCommentForm">

	<vb-ui-html-editor name="text" #htmlEditor #commentText="ngModel" [(ngModel)]="text" [attr.aria-label]="'Media_Videos_Comments_AddComment' | translate" [disabled]="processing" [editorConfig]="editorConfig" (editorLoaded)="onEditorLoaded(htmlEditor)" [vbMaxLength]="1000" required>
	</vb-ui-html-editor>

	<div [ngClass]="styles.btnSection">
		<button type="button" [ngClass]="styles.btn" (click)="resetComment()" vbUiBtnSecondaryNgx>
			{{ 'Cancel' | translate }}
		</button>
		<button type="button" [ngClass]="styles.btn" class="margin-left" [disabled]="commentText.invalid || processing" vbUiBtnPrimaryNgx (click)="addComment()">
			<span [hidden]="processing">
				{{ 'Media_Videos_Comments_Post' | translate }}
			</span>
			<span [hidden]="!processing">
				<vb-loading-spinner [size]="'small'"></vb-loading-spinner>
				{{ 'Processing' | translate }}
			</span>
		</button>
	</div>

	<div *ngIf="commentText.invalid" role="alert" vbUiErrorMessage>
		<div *ngIf="commentText.errors.required">{{ 'ThisFieldIsRequired' | translate }}</div>
		<div *ngIf="commentText.errors.vbMaxLength">{{ 'Media_Videos_Comments_ExceedsCharacterCount' | translate }}</div>
	</div>
</section>
